import { Stack } from '@mui/material';
import { buttonTextMessages } from '@ocx-app/modules/localization/button-text.messages';
import { Form } from 'react-final-form';

import { FormattedMessage, useIntl } from 'react-intl';
import { emailFieldDescriptionMessage } from '@ocx/feat-edit-profile';
import { LoadingButton, SizingMultiplier } from '@ocx/ui';
import { TextField, localization, FormIconHelperText } from '@ocx/ui-forms';
import { InfoIcon } from '@ocx/ui-icons';
import { ServiceLink } from '@ocx/ui-modals';

import { CompleteEmailFormValues } from './complete-email-action-sheet.types';
import { completeEmailFormValidationSchema } from './complete-email-action-sheet.validation';

type CompleteEmailActionSheetViewProps = {
  onSubmit(values: CompleteEmailFormValues): void;
};

const initialValues: CompleteEmailFormValues = { email: '' };

export const CompleteEmailActionSheetView = (props: CompleteEmailActionSheetViewProps) => {
  const intl = useIntl();
  const { onSubmit } = props;

  return (
    <Form<CompleteEmailFormValues>
      validate={completeEmailFormValidationSchema}
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, hasValidationErrors, dirty, submitting }) => (
        <Stack component="form" noValidate alignItems="justify" spacing={SizingMultiplier.md} onSubmit={handleSubmit}>
          <Stack spacing={SizingMultiplier.sm}>
            <TextField
              variant="outlined"
              name="email"
              type="email"
              label={intl.formatMessage(localization.formLabelMessages['form-label:email'])}
              fullWidth
            />
            <FormIconHelperText icon={InfoIcon} text={intl.formatMessage(emailFieldDescriptionMessage)} />
          </Stack>
          <LoadingButton loading={submitting} disabled={hasValidationErrors || !dirty} type="submit" fullWidth>
            <FormattedMessage {...buttonTextMessages['button-text:save']} />
          </LoadingButton>
          <ServiceLink />
        </Stack>
      )}
    />
  );
};
